// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3LcYL","additionalInfo":"AgreementModal_additionalInfo__rhiY6"};